import { servers } from "@vviinn/user-managment-client-ts";
import { NameValuePair, QueryableField, Action } from "../types";

const SERVER_INDEX =
  import.meta.env.VITE_BFF_ENVIRONMENT === "production" ? 0 : 1;

export const makeRequest = async <T, ResponseType>(
  formType: string,
  data: T,
  bearerString: string,
  requestType?: string,
  select?: QueryableField[],
  readonlyColumns?: Action["readonly_columns"],
  filters?: NameValuePair[],
  method?: string,
  label?: string,
  navigateUrl?: string,
  actionId?: string,
) => {
  const headers: Headers = new Headers({
    Authorization: bearerString,
  });

  //TODO replace url logic when make the component independent
  const url = servers[SERVER_INDEX]["url"];

  const requestData: RequestInit = {
    method: method ?? "PUT",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: headers,
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  if (data) {
    const mainData = {
      item: {
        name: formType,
        action: {
          id: actionId,
          rel: ["form"],
          href: "",
          method: "PUT",
          request_type: requestType ?? "GET",
          label: label,
          navigate_url: navigateUrl,
          parameters: {
            form: data,
            path: {},
            query: {},
          },
          form_type: formType,
          select: select,
          filters: filters,
          readonly_columns: readonlyColumns,
        },
      },
    };

    requestData.body = JSON.stringify(mainData);
  }

  return fetch(`${url}/form`, requestData)
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      return;
    })
    .then((responseData) => {
      return responseData as ResponseType;
    })
    .catch((error) => console.warn(error));
};
